import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';

import FilterApi from '../server/FilterApi';

function createSuccessHandler() {
    const actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            Dispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    const actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            Dispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}

const _handleFormError = createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR);
const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);

export default {

    getAll: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.FILTER_LIST);
        const handleError = createErrorHandler(ActionTypes.FILTER_LIST_ERROR);

        return FilterApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    getById: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.FILTER_INFO);
        const handleError = createErrorHandler(ActionTypes.FILTER_INFO_ERROR);

        return FilterApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    save: function(entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.FILTER_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.FILTER_INFO_ERROR);

        return FilterApi.save(entity)
            .then(handleSuccess, _handleFormError)
            .catch(_handleException);
    },

    update: function(id, entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.FILTER_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.FILTER_UPDATE_ERROR);

        return FilterApi.update(id, entity)
            .then(handleSuccess, _handleFormError)
            .catch(_handleException);
    },

    delete: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.FILTER_DELETE);
        const handleError = createErrorHandler(ActionTypes.FILTER_DELETE_ERROR);

        return FilterApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    search: (searchText, params) => {
        const types = {
            request:    ActionTypes.SEARCH_REQUEST,
            success:    [ActionTypes.SEARCH_SUCCESS, ActionTypes.FILTER_LIST],
            failure:    ActionTypes.SEARCH_FAILURE
        };

        Dispatcher.dispatchAsync(FilterApi.search(searchText, params), types, {searchText, params});
    },

    getResults: (id, params, clearAll = true) => {
        const types = {
            request:    ActionTypes.FILTER_RESULTS_REQUEST,
            success:    ActionTypes.FILTER_RESULTS_SUCCESS,
            failure:    ActionTypes.FILTER_RESULTS_FAILURE
        };

        return Dispatcher.dispatchAsync(FilterApi.getResults(id, params), types, {id, params, clearAll});
    },

};
